import { Controller } from "@hotwired/stimulus"

// Expands a multi-day trip row in the trip picker so the traveler can choose
// which day to add the thing to. Only one row stays open at a time.
export default class extends Controller {
  static targets = ["trigger", "days", "chevron"]

  toggle(event) {
    event.preventDefault()
    const nextOpen = !this.element.classList.contains("is-open")

    this.closeSiblings()
    this.setOpen(nextOpen)
  }

  closeSiblings() {
    this.element.parentElement?.querySelectorAll("[data-controller~='trip-picker-row'].is-open").forEach((row) => {
      if (row === this.element) return

      row.classList.remove("is-open")
      row.querySelector("[data-trip-picker-row-target='days']")?.classList.add("hidden")
      const trigger = row.querySelector("[data-trip-picker-row-target='trigger']")
      trigger?.setAttribute("aria-expanded", "false")
      row.querySelector("[data-trip-picker-row-target='chevron']")?.classList.remove("rotate-180")
    })
  }

  setOpen(open) {
    this.element.classList.toggle("is-open", open)
    this.daysTarget.classList.toggle("hidden", !open)
    this.triggerTarget.setAttribute("aria-expanded", String(open))
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", open)
    }
  }
}
